import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { useState , useEffect } from "react";
import CustomProgress from "./progressbar";
import { CircularGauge } from "@progress/kendo-react-gauges";
import { scheduleNames } from "./scheduleNames";
import { FormattedMessage, useIntl } from "react-intl";
import Account from "../../utils/apiConfig";
import ErrorHandler from "../../utils/errorConfig";
import ApiServices from "../../service/apiService";

const accountInstance = Account.getInstance();
const errorInstance = ErrorHandler.getErrorInstance();
const api = ApiServices.getInstance();

export interface ScheduleDisplayProps {}
export function ScheduleDisplay(props: ScheduleDisplayProps) {
  const intl = useIntl();
  const [filterValue, setFilterValue] = useState("");
  const [show, setShow] = useState<boolean>(true);
  const [schedules, setSchedules] = useState<any[]>([]);
  const [innerShowMap, setInnerShowMap] = useState<{[key: number]: boolean}>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedValue, setSelectedValue] = useState(null);
  const [statusFilter, setStatusFilter] = useState<string>("");
  // pagination state
  const [pageIndex, setPageIndex] = useState<number>(0);
  const [pageTokens, setPageTokens] = useState<(string | null)[]>([null]); // token used to fetch current page
  const [nextToken, setNextToken] = useState<string | null>(null); // token returned by API for next page
  const [hasMore, setHasMore] = useState<boolean>(false);
  // client-side cache for pages to avoid repeat API calls when navigating
  const [pagesCache, setPagesCache] = useState<{ [index: number]: any[] }>({});
  const [nextTokenByPage, setNextTokenByPage] = useState<{ [index: number]: string | null }>({});
  const PAGE_SIZE = 20;
  let value ;
  
  const handleInnerIconClick = (index: number) => {
    console.log('index', index);
    setInnerShowMap((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  console.log("search val", filterValue);

  // Status mapping function
  const getStatusValue = (statusText: string): string => {
    const statusMap: { [key: string]: string } = {
      [intl.formatMessage({ id: "analytics.scheduleDisplay.defaultStatus" })]: "ALL STATUS",
      [intl.formatMessage({ id: "analytics.scheduleDisplay.completedProgress" })]: "COMPLETED",
      [intl.formatMessage({ id: "analytics.scheduleDisplay.inProgress" })]: "ACTIVE", 
      [intl.formatMessage({ id: "analytics.scheduleDisplay.paused" })]: "PAUSED",
      [intl.formatMessage({ id: "analytics.scheduleDisplay.notStarted" })]: "NOT_STARTED"
    };
    return statusMap[statusText] || "";
  };

  // shared fetch function used by status changes, search click and pagination
  const fetchSchedules = async(options?: { status?: string; searchText?: string; lastKey?: string | null; pageForCache?: number }) => {
    try {
      setLoading(true);
      console.log("fetching schedules", accountInstance.accntId);

      const hasFilters = Boolean(options?.status && options.status !== "ALL STATUS") || Boolean(options?.searchText);
      let apiUrl = `${accountInstance.accntId}/analytics/scheduleAnalytics`;

      const queryParams: string[] = [];
      // Paginate only when no filters are applied; if filters present, request the full filtered set
      if (!hasFilters ) {
        queryParams.push(`limit=${PAGE_SIZE}`);
        if (options?.lastKey) {
          queryParams.push(`lastKey=${encodeURIComponent(options.lastKey)}`);
        }
      }
      if (options?.status && options.status !== "ALL STATUS" ) {
        queryParams.push(`status=${encodeURIComponent(options.status)}`);
      }
      if (options?.searchText) {

        queryParams.push(`searchText=${encodeURIComponent(capitalizeWords(options.searchText))}`);
      }
      if (queryParams.length) {
        apiUrl += `?${queryParams.join("&")}`;
      }

      const response = await api.makeRequest(apiUrl, "GET");
      const list: any[] = response?.sheduleList || [];
      setSchedules(list);
      // update pagination tokens based on response
      const respLastKey: string | null = response?.lastKey || null;
      setNextToken(respLastKey);
      setHasMore(Boolean(respLastKey));
      console.log("schedule analytics api response.sheduleList", response?.sheduleList);

      // cache page data and next token for this page to prevent redundant fetches
      const cacheIndex = typeof options?.pageForCache === 'number' ? options.pageForCache : pageIndex;
      setPagesCache((prev) => ({ ...prev, [cacheIndex]: list }));
      setNextTokenByPage((prev) => ({ ...prev, [cacheIndex]: respLastKey }));
    } catch(error) {
      console.log('error', error);
    } finally {
      setLoading(false);
    }
  };

  function capitalizeWords(text: string): string {
    return text
      .toLowerCase()
      .split(' ')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  // fetch on status change only (reset pagination)
  useEffect(() => {
    // reset pagination when status changes
    setPageIndex(0);
    setPageTokens([null]);
    setNextToken(null);
    setHasMore(false);
    setPagesCache({});
    setNextTokenByPage({});
    fetchSchedules({ status: statusFilter || undefined, lastKey: null, pageForCache: 0 });
  }, [statusFilter]);
    
  const colors = [
    {
      from : 0,
      to: value,
      color: "#4FB94D",
    },
    {
      from: value,
      to: 100,
      color: "#FF8274",
    },
  ];

 
  const gaugeStyles = {
    display: "block",
    width: "64px",
    height: "64px",
    rangeSize: 100,
  };
  
  const allData = [
    intl.formatMessage({ id: "analytics.scheduleDisplay.defaultStatus" }),
    intl.formatMessage({ id: "analytics.scheduleDisplay.completedProgress" }),
    intl.formatMessage({ id: "analytics.scheduleDisplay.inProgress" }),
    intl.formatMessage({ id: "analytics.scheduleDisplay.paused" }),
    intl.formatMessage({ id: "analytics.scheduleDisplay.notStarted" }),
  ];

  const handleIconClick = () => {
    console.log("inside handle click");
    setShow(!show);
  };

  const minHeightClass = "h-12";
  const maxHeightClass = "h-screen";

  const innerHeightMinClass = "h-10";
  const innerHeightMaxClass = "h-auto";
  
  console.log("show field", show);

  const handleDropDownChange = (event: DropDownListChangeEvent) => {
    setSelectedValue(event.value);
    const statusValue = getStatusValue(event.value);
    setStatusFilter(statusValue);
  };
  
  console.log('innerShowMap', innerShowMap);
  
  return (
    <div
      className={`bg-mk-white rounded-lg shadow-md mt-6 overflow-y-auto 
         ${show ? maxHeightClass : minHeightClass}`}
    >
      <div className="flex mt-2 items-center">
        <div className="text-mk-primary-bright text-xl font-semibold pl-3 pt-1 mr-4">
          <FormattedMessage id="schedules.title" />
        </div>

        <div>
          <DropDownList
            data={allData}
            defaultValue={intl.formatMessage({
                id: "analytics.scheduleDisplay.defaultStatus",
              })}
            onChange={handleDropDownChange}
            className="w-48 text-sm mr-4 bg-mk-primary-50"
          />
        </div>
        <div>
          <div className="flex items-center border rounded border-mk-primary">
            <input
              className="w-64 h-6 flex items-center pl-1 focus:outline-none rounded"
              placeholder="Search"
              onChange={(e) => setFilterValue(e.target.value)}
            />

            <FontAwesomeIcon
              icon={["far", "search" as IconName]}
              className="fa-fw w-4 h-4 pr-1"
              color="#9AA4EC"
              onClick={() => {
                const searchText = filterValue.trim();
                if (!searchText) return;
                // reset pagination on new search
                setPageIndex(0);
                setPageTokens([null]);
                setNextToken(null);
                setHasMore(false);
                setPagesCache({});
                setNextTokenByPage({});
                fetchSchedules({ status: statusFilter || undefined, searchText, lastKey: null, pageForCache: 0 });
              }}
            />
          </div>
        </div>

        <div className="ml-auto mr-4" onClick={handleIconClick}>
          <FontAwesomeIcon
            icon={["fas", "fa-play" as IconName]}
            className={`h-5 w-4.5 mx-3 hover:cursor-pointer text-mk-primary ${
              show ? "rotate-90" : ""
            }`}
          />
        </div>
      </div>

      {show && (
        <div className="flex text-mk-text-grey mt-6 text-sm font-normal px-5 py-3 gap-4">
        {/* Left section - matches data row structure */}
        <div className="flex flex-[2] justify-around items-center gap-6 px-4">
          <div className="flex pl-2 flex-[2]">
            <FormattedMessage id="analytics.summaryDisplay.scheduleName" />
          </div>
          
          <div className=" flex-[1.2]">
            <FormattedMessage id="analytics.summaryDisplay.courseName" />
          </div>
      
          <div className=" flex-[1.25] pr-2z">
            <FormattedMessage id="analytics.scheduleDisplay.cohortName" />
          </div>
          
          <div className="flex justify-center flex-[0.5]">
            <FormattedMessage id="analytics.scheduleDisplay.deliveryChannel" />
          </div>
        </div>
      
        {/* Right section - matches data row structure */}
        <div className="flex flex-1 justify-around items-center gap-4">
          <div className="flex flex-col items-center justify-center">
            <div className="text-center">
              <FormattedMessage id="analytics.scheduleDisplay.Users" />
              <div className="border-b border-mk-grey w-20"></div>
            </div>
      
            <div className="flex flex-row justify-between items-center mt-1 gap-3">
              <div>
                <FormattedMessage id="analytics.scheduleDisplay.Total" />
              </div>
              <div>
                <FormattedMessage id="analytics.scheduleDisplay.Active" />
              </div>
            </div>
          </div>
      
          <div className="flex justify-center">
            <div>
              <FormattedMessage id="analytics.scheduleDisplay.completion" />
            </div>
            <div>
              <FormattedMessage id="analytics.scheduleDisplay.percent" />
            </div>
          </div>
      
          <div className="flex flex-col">
            <div>
              <FormattedMessage id="analytics.scheduleDisplay.Response" />
            </div>
            <div>
              <FormattedMessage id="analytics.scheduleDisplay.time" />
            </div>
          </div>
      
          <div className="flex flex-col">
            <div>
              <FormattedMessage id="analytics.scheduleDisplay.assessment" />
            </div>
            <div>
              <FormattedMessage id="analytics.scheduleDisplay.score" />
            </div>
          </div>
        </div>
        
        {/* Empty space for toggle button alignment */}
        <div className="flex-shrink-0 ml-auto mr-3 w-[20px]"></div>
      </div>
      )}
      <div className="flex justify-center items-center mt-2">
        <div className="border-b border-mk-grey w-[95%]"></div>
      </div>

		{/* Loading and empty states */}
		{loading && (
			<div className="flex justify-center items-center py-6 text-sm text-mk-text-grey">
				{intl.formatMessage({ id: "common.loading", defaultMessage: "Loading..." })}
			</div>
		)}
		{!loading && (!schedules || schedules.length === 0) && (
			<div className="flex justify-center items-center py-6 text-sm text-mk-text-grey">
				{intl.formatMessage({ id: "analytics.scheduleDisplay.empty", defaultMessage: "No schedules found" })}
			</div>
		)}

		{!loading && schedules?.map((schedule: any, index: number) => (
        <div
          key={index}
          className={`border-t border-l border-r text-mk-very-dark-grey bg-mk-primary-50 min-h-14 rounded-t-xl cursor-pointer mt-4 text-xs ml-6 mr-6 font-medium overflow-y-auto ${
            innerShowMap[index] ? innerHeightMaxClass : innerHeightMinClass
          }`}
        >
          <div className="flex items-center h-12 gap-4">
            {/* Left section - 67% */}
            <div className="flex flex-[2] justify-around items-center gap-3 px-5 ">
              <div className="flex justify-start flex-wrap flex-[2]">
                <div>{schedule.scheduleName}</div>
              </div>
              
              <div className="flex flex-wrap flex-[1.2]">
                {schedule.courseName}
              </div>

              <div className="flex-[1.2]">
                {schedule.cohortName}
              </div>

              <div className=" flex justify-center flex-[0.6]">
                <div className="p-1">
                  <img
                    src={
                      schedule?.channels?.[0] === "TEAMS"
                        ? require(`../../assets/images/teams.png`)
                        : schedule?.channels?.[0] === "WHATSAPP"
                        ? require(`../../assets/images/whatsapp.png`)
                        : schedule?.channels?.[0] === "SLACK"
                        ? require(`../../assets/images/slack.png`)
                        : require(`../../assets/images/analyticsMail.png`)
                    }
                    alt={schedule?.channels?.[0] || "email"}
                    className="w-6 h-6"
                  />
                </div>
              </div>
            </div>

            {/* Right section - 33% */}
            <div className="flex flex-1 justify-around items-center gap-4">
              <div className="flex flex-1 justify-center items-center gap-3">
                <div>{schedule.totalUsers}</div>
                <div>{schedule.inProgressUsers}</div>
              </div>

              <div className="flex flex-1 justify-center">
                { schedule.avgProgress !== "N/A" 
                  ? Math.floor(schedule.avgProgress) + "%" 
                  : 0 }
              </div>
              <div className="flex flex-1 justify-center">
                { schedule.avgResponseTime !== 'N/A' 
                  ? (schedule.avgResponseTime >= 2 ? Math.floor(schedule.avgResponseTime) +  "mins" : Math.floor(schedule.avgResponseTime) + "min")
                  : 0}
              </div>
              <div className="flex flex-1 justify-center">
                {schedule.avgAsmtScore !== 'N/A' 
                  ? Math.floor(schedule.avgAsmtScore) + "%" 
                  : `0%`}
              </div>
            </div>
            
            {/* Toggle button */}
            <button 
              className="flex-shrink-0 ml-auto mr-3" 
              onClick={() => handleInnerIconClick(index)}
            >
              <FontAwesomeIcon
                icon={["fas", "fa-play" as IconName]}
                className={`h-5 w-4.5 hover:cursor-pointer text-mk-primary-bright transition-transform ${
                  innerShowMap[index] ? "rotate-90" : ""
                }`}
              />
            </button>
          </div>

          {innerShowMap[index] && (
            <>
              {/* Header row */}
              <div className="flex text-mk-grey text-sm mt-4 px-6">
                <div className="flex w-full gap-4">
                  <div className="flex-1 flex justify-center">
                    <FormattedMessage id="analytics.scheduleDisplay.userName" />
                  </div>
                  <div className="flex-1 flex justify-center">
                    <FormattedMessage id="analytics.scheduleDisplay.cardsSent" />
                  </div>
                  <div className="flex-1 flex justify-center">
                    <FormattedMessage id="analytics.scheduleDisplay.assessmentScore" />
                  </div>
                  <div className="flex-1 flex justify-center">
                    <FormattedMessage id="analytics.scheduleDisplay.avgresponseTime" />
                  </div>
                </div>
              </div>

              {/* Divider */}
              <div className="flex justify-center items-center mt-2">
                <div className="border-b border-mk-grey w-[95%]"></div>
              </div>

              {/* Data rows */}
              {schedule?.userScheduleAnalytics?.map((user: any, userIndex: number) => (
                <div key={userIndex} className="flex text-mk-very-dark-grey text-xs mt-2 pb-4 items-center px-6">
                  <div className="flex w-full gap-4">
                    {/* Username */}
                    <div className="flex-1 flex justify-center items-center">
                      {user.username}
                    </div>

                    {/* Cards Sent with Progress */}
                    <div className="flex-1 flex items-center justify-center gap-2 text-base font-semibold">
                      {/* <div className="flex-shrink-0">{user.cardSent}</div> */}
                      <div className="flex-1 min-w-0">
                        <CustomProgress
                          progress={user?.cardSent <= schedule.totalCards ? user.cardSent : 0}
                          progressColor="bg-mk-primary-bright"
                          completeColor="#FFF"
                          totalWidth={100}
                          textColor="#6464E5"
                          totalCardCount={schedule.totalCards}
                        />
                      </div>
                      <div className="flex-shrink-0">{schedule.totalCards}</div>
                    </div>

                    {/* Assessment Score */}
                    <div className="flex-1 flex justify-center items-center">
                      <div className="asmtScore flex flex-col items-center justify-center">
                        {/* <CircularGauge
                          style={gaugeStyles}
                          scale={{ rangeSize: 5, rangePlaceholderColor: "#ff3874" }}
                          value={typeof user?.asmtScore === 'number' ? user.asmtScore : 0}
                          colors={colors}
                        /> */}
                        <p className="asmt ">{typeof user?.asmtScore === 'number' ? `${user.asmtScore}%` : '0%'}</p>
                      </div>
                    </div>

                    {/* Response Time */}
                    <div className="flex-1 flex justify-center items-center">
                      {user.responseTime}
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      ))}
      {/* Pagination controls */}
      <div className="flex items-center justify-end gap-3 px-6 py-4">
        <button
          className={`px-3 py-1 rounded border ${pageIndex > 0 ? 'text-mk-primary border-mk-primary' : 'text-mk-grey border-mk-grey cursor-not-allowed'}`}
          disabled={pageIndex === 0 || loading}
          onClick={() => {
            if (pageIndex === 0) return;
            const newIndex = pageIndex - 1;
            // serve from cache if available
            if (pagesCache[newIndex]) {
              setPageIndex(newIndex);
              setSchedules(pagesCache[newIndex]);
              const cachedNext = nextTokenByPage[newIndex] ?? null;
              setNextToken(cachedNext);
              setHasMore(Boolean(cachedNext));
              return;
            }
            // otherwise fetch using stored token
            setPageIndex(newIndex);
            const tokenToUse = pageTokens[newIndex] ?? null;
            fetchSchedules({ status: statusFilter || undefined, lastKey: tokenToUse, pageForCache: newIndex });
          }}
        >
          {intl.formatMessage({ id: "common.previous", defaultMessage: "Previous" })}
        </button>
        <div className="text-xs text-mk-text-grey">
          {intl.formatMessage({ id: "common.page", defaultMessage: "Page" })} {pageIndex + 1}
        </div>
        <button
          className={`px-3 py-1 rounded border ${hasMore ? 'text-mk-primary border-mk-primary' : 'text-mk-grey border-mk-grey cursor-not-allowed'}`}
          disabled={!hasMore || loading}
          onClick={() => {
            if (!nextToken) return;
            const newIndex = pageIndex + 1;
            // if next page is already cached, serve it and avoid API call
            if (pagesCache[newIndex]) {
              setPageIndex(newIndex);
              setSchedules(pagesCache[newIndex]);
              const cachedNext = nextTokenByPage[newIndex] ?? null;
              setNextToken(cachedNext);
              setHasMore(Boolean(cachedNext));
              return;
            }
            // otherwise record token path and fetch
            const newTokens = [...pageTokens];
            newTokens[newIndex] = nextToken;
            setPageTokens(newTokens);
            setPageIndex(newIndex);
            fetchSchedules({ status: statusFilter || undefined, lastKey: nextToken, pageForCache: newIndex });
          }}
        >
          {intl.formatMessage({ id: "common.next", defaultMessage: "Next" })}
        </button>
      </div>
    </div>
  );
}